import { render, staticRenderFns } from "./ServidoresForm.vue?vue&type=template&id=6f548735&"
import script from "./ServidoresForm.vue?vue&type=script&lang=js&"
export * from "./ServidoresForm.vue?vue&type=script&lang=js&"
import style0 from "./ServidoresForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports